module.exports = __webpack_public_path__ + "static/img/alertsFlow.61929a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alertsFlow.png
// module id = 127
// module chunks = 1